// @flow
import type {Product, ProductVariant, ProductDetail} from '../../entities';

export const getProductItemOriginalPrice = (item: {
  product: Product,
  productVariant?: ProductVariant,
}) => {
  if (item.productVariant) {
    if (item.productVariant.offerPrice) return item.productVariant.offerPrice;
    return Number(item.productVariant.price);
  }
  if (item.product.offerPrice) return item.product.offerPrice;
  return Number(item.product.price);
};

// export const getVariantOptionLowestPrice = (variants: ProductVariant[]) => {
//   let lowestVariant = variants[0];
//   variants.forEach(variant => {
//     if (parseFloat(lowestVariant.price) > parseFloat(variant.price))
//       lowestVariant = variant;
//   });
//   return lowestVariant;
// };

type ProductPricing = {
  price: string,
  offerPrice?: string,
};

const getMinOfferPriceVariant = (variants: ProductVariant[]) => {
  const offerPriceVariants = variants.filter(variant => variant.offerPrice);
  if (offerPriceVariants.length) {
    return offerPriceVariants.reduce((minVariant, variant) => {
      const minPrice = parseFloat(minVariant.offerPrice);
      const currentPrice = parseFloat(variant.offerPrice);
      return minPrice <= currentPrice ? minVariant : variant;
    }, offerPriceVariants[0]);
  }
};

const getMinRegularPriceVariant = (variants: ProductVariant[]) => {
  return variants.reduce((minVariant, variant) => {
    const minPrice = parseFloat(minVariant.price);
    const currentPrice = parseFloat(variant.price);
    return minPrice <= currentPrice ? minVariant : variant;
  }, variants[0]);
};

export const getVariantOptionWithLowestPrice = (
  product: ProductDetail
): any => {
  let variantOption;
  if (
    product.productVariantSetting?.enabled &&
    product.productVariantSetting.options &&
    product.productVariantSetting.variants &&
    product.productVariantSetting.variants.length &&
    product.productVariantSetting.variants.filter(v => v.enabled).length
  ) {
    const enabledVariants = product.productVariantSetting.variants.filter(
      v => v.enabled
    );
    if (enabledVariants) {
      variantOption = enabledVariants[0];
      let price = variantOption.offerPrice
        ? variantOption.offerPrice
        : variantOption.price;
      enabledVariants.forEach(variant => {
        const currVariantPrice = variant.offerPrice
          ? variant.offerPrice
          : variant.price;
        if (parseFloat(price) > parseFloat(currVariantPrice))
          variantOption = variant;
      });
    }
  }
  return variantOption ? variantOption.combinations : undefined;
};

export const getProductItemPricing = (product: Product): ProductPricing => {
  const enabledVariants = !!product.productVariantSetting?.enabled;
  const variants = (product.productVariantSetting.variants ?? []).filter(
    v => v.enabled
  );

  const pricing: ProductPricing = {price: ''};

  if (enabledVariants && variants.length) {
    const minOfferPriceVariant = getMinOfferPriceVariant(variants);
    const minPriceVariant = getMinRegularPriceVariant(variants);

    if (minOfferPriceVariant) {
      if (
        parseFloat(minOfferPriceVariant.offerPrice) >
        parseFloat(minPriceVariant.price)
      ) {
        pricing.price = minPriceVariant.price;
      } else {
        pricing.price = minOfferPriceVariant.price;
        pricing.offerPrice = minOfferPriceVariant.offerPrice;
      }
    } else {
      pricing.price = minPriceVariant.price;
    }
  } else {
    pricing.price = product.price;
    if (
      product.offerPrice &&
      parseFloat(product.offerPrice) < parseFloat(product.price)
    ) {
      pricing.offerPrice = product.offerPrice;
    }
  }

  return pricing;
};
